import React from 'react';
import CollapsibleCard from 'core/components/collapsible-card';

import useStyles from './collapsible-section.styles';

const CollapsibleSection = ({ children, ...props }) => {
  const classes = useStyles();
  return (
    <CollapsibleCard
      type="secondary"
      initialOpen
      keepContentMounted
      classes={{
        collapse: classes.collapse,
        container: classes.container,
        containerOpen: classes.containerOpen,
        content: classes.content,
        buttonContainer: classes.buttonContainer,
        header: classes.header
      }}
      {...props}
    >
      {children}
    </CollapsibleCard>
  );
};

export default CollapsibleSection;
